module.exports = __webpack_public_path__ + "img/Group 19-2.2ef01555.svg";